module.exports = __webpack_public_path__ + "img/icon-flag-pl.aa3ad8a9.svg";